var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6922 3.24259C17.6129 2.49741 17.2806 1.80191 16.7508 1.27202C16.2209 0.742124 15.5254 0.409853 14.7802 0.330589C10.9378 -0.0802483 7.06256 -0.0802483 3.22018 0.330589C2.47507 0.410031 1.77967 0.74236 1.24981 1.27222C0.719952 1.80208 0.387624 2.49748 0.308181 3.24259C-0.102727 7.0853 -0.102727 10.9609 0.308181 14.8036C0.387838 15.5485 0.720262 16.2437 1.2501 16.7733C1.77994 17.303 2.47522 17.6352 3.22018 17.7146C7.06289 18.1255 10.9385 18.1255 14.7812 17.7146C15.5262 17.6351 16.2214 17.3027 16.7511 16.7729C17.2808 16.243 17.613 15.5476 17.6922 14.8026C18.103 10.9602 18.103 7.08497 17.6922 3.24259Z",
    fill: "url(#paint0_radial_1180_652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.713 3.8935C16.6427 3.23242 16.348 2.61539 15.878 2.1452C15.408 1.67502 14.7911 1.38007 14.13 1.3095C10.7201 0.94501 7.281 0.94501 3.87104 1.3095C3.20988 1.38003 2.59283 1.67494 2.12266 2.14511C1.65249 2.61528 1.35758 3.23233 1.28704 3.8935C0.922548 7.30345 0.922548 10.7425 1.28704 14.1525C1.3574 14.8137 1.65225 15.4309 2.12246 15.9011C2.59266 16.3713 3.20981 16.6661 3.87104 16.7365C7.28099 17.1011 10.7201 17.1011 14.13 16.7365C14.7913 16.6661 15.4084 16.3713 15.8786 15.9011C16.3488 15.4309 16.6437 14.8137 16.714 14.1525C17.0784 10.7425 17.078 7.30341 16.713 3.8935Z",
    fill: "url(#paint1_linear_1180_652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.27002 14.4243C0.282686 14.549 0.295353 14.6733 0.30802 14.7973C0.387499 15.5423 0.719864 16.2376 1.24974 16.7673C1.77961 17.297 2.47499 17.6291 3.22002 17.7083C7.06273 18.1193 10.9383 18.1193 14.781 17.7083C15.5259 17.6289 16.221 17.2967 16.7507 16.767C17.2804 16.2373 17.6126 15.5422 17.692 14.7973C17.7054 14.6727 17.7184 14.5483 17.731 14.4243H0.27002Z",
    fill: "url(#paint2_linear_1180_652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6919 14.8025C17.9122 12.7393 18.0144 10.6653 17.9979 8.59048L13.8839 4.47648C13.6133 4.17309 13.2829 3.92897 12.9134 3.75945C12.5439 3.58994 12.1433 3.4987 11.7369 3.49148C9.92287 3.42648 8.10287 3.42948 6.28787 3.49148C5.58706 3.50471 4.91453 3.77029 4.39376 4.23944C3.87299 4.7086 3.53891 5.34985 3.45287 6.04548C3.40487 6.30848 3.37687 6.57448 3.33887 6.83948V11.2045C3.35987 11.3455 3.38987 11.4865 3.39987 11.6285C3.41761 12.0457 3.51755 12.4554 3.69395 12.834C3.87036 13.2125 4.11977 13.5525 4.42787 13.8345L8.61487 18.0215C10.6727 18.0357 12.7297 17.9332 14.7759 17.7145C15.5218 17.6361 16.2182 17.3042 16.7489 16.7742C17.2796 16.2442 17.6124 15.5483 17.6919 14.8025Z",
    fill: "url(#paint3_linear_1180_652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6919 14.8026C17.6124 15.5467 17.2807 16.2413 16.7519 16.7709C16.2231 17.3004 15.5289 17.6331 14.7849 17.7136C12.7387 17.9322 10.6817 18.0347 8.62386 18.0206L4.44287 13.8396C4.95815 14.2836 5.61181 14.5346 6.29186 14.5496C8.10586 14.6176 9.92687 14.6156 11.7409 14.5496C12.5076 14.5398 13.2397 14.2285 13.7786 13.6829C14.3174 13.1373 14.6197 12.4014 14.6199 11.6346C14.6749 9.89257 14.6749 8.14556 14.6199 6.40356C14.6085 5.69579 14.3503 5.01419 13.8899 4.47656L18.0019 8.58856C18.0169 10.6641 17.9134 12.7388 17.6919 14.8026Z",
    fill: "url(#paint4_linear_1180_652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.125 7.07344C10.8615 6.78833 10.5432 6.55937 10.1892 6.40027C9.83508 6.24116 9.45253 6.1552 9.06442 6.14753C8.67631 6.13987 8.29067 6.21066 7.93059 6.35566C7.5705 6.50067 7.2434 6.71689 6.96892 6.99138C6.69443 7.26586 6.47821 7.59296 6.3332 7.95305C6.1882 8.31313 6.11741 8.69878 6.12507 9.08688C6.13274 9.47499 6.2187 9.85754 6.3778 10.2116C6.53691 10.5657 6.76587 10.884 7.05098 11.1474L13.722 17.8174C14.0753 17.7868 14.4283 17.7535 14.781 17.7175C15.5261 17.638 16.2215 17.3057 16.7514 16.7758C17.2812 16.246 17.6135 15.5506 17.693 14.8054C17.7303 14.4528 17.7636 14.0998 17.793 13.7464L11.125 7.07344Z",
    fill: "url(#paint5_linear_1180_652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9651 10.9616L12.5971 5.59365C12.5379 5.51592 12.4627 5.45176 12.3767 5.40548C12.2906 5.35919 12.1957 5.33184 12.0982 5.32528C12.0007 5.31871 11.9029 5.3331 11.8115 5.36744C11.72 5.40177 11.6369 5.45528 11.5678 5.52437C11.4987 5.59346 11.4452 5.67653 11.4109 5.76801C11.3765 5.85949 11.3622 5.95725 11.3687 6.05474C11.3753 6.15223 11.4026 6.24718 11.4489 6.33323C11.4952 6.41928 11.5594 6.49443 11.6371 6.55364L17.8691 12.7866C17.9111 12.178 17.9431 11.5696 17.9651 10.9616Z",
    fill: "url(#paint6_linear_1180_652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34277 6.83937C3.37977 6.57437 3.40878 6.30837 3.45678 6.04537C3.54273 5.35041 3.87622 4.70969 4.39616 4.24062C4.9161 3.77156 5.58767 3.50556 6.28778 3.49137C8.10278 3.42937 9.92278 3.42537 11.7368 3.49137C12.5034 3.5011 13.2353 3.81234 13.7741 4.35771C14.3129 4.90309 14.6153 5.63872 14.6158 6.40537C14.6704 8.14737 14.6704 9.89104 14.6158 11.6364C14.6153 12.403 14.3129 13.1387 13.7741 13.684C13.2353 14.2294 12.5034 14.5406 11.7368 14.5504C9.92278 14.6164 8.10178 14.6174 6.28778 14.5504C5.523 14.5293 4.79594 14.2135 4.25851 13.669C3.72107 13.1245 3.41484 12.3934 3.40378 11.6284C3.39478 11.4864 3.36377 11.3454 3.34277 11.2044V6.83937ZM9.00178 13.5794C9.83178 13.5794 10.6628 13.6044 11.4928 13.5734C11.7758 13.5883 12.0588 13.5436 12.3235 13.4423C12.5882 13.3409 12.8287 13.1852 13.0295 12.9851C13.2302 12.785 13.3868 12.5451 13.489 12.2807C13.5912 12.0163 13.6367 11.7335 13.6228 11.4504C13.6601 9.8317 13.6601 8.21238 13.6228 6.59238C13.6384 6.30902 13.5939 6.02557 13.4922 5.76063C13.3905 5.49568 13.234 5.25523 13.0329 5.05504C12.8317 4.85485 12.5905 4.69945 12.3251 4.59903C12.0597 4.49861 11.7761 4.45545 11.4928 4.47237C9.84344 4.43771 8.19344 4.43771 6.54278 4.47237C6.26199 4.4542 5.98053 4.49548 5.71678 4.59351C5.45304 4.69155 5.21294 4.84414 5.01219 5.0413C4.81144 5.23846 4.65456 5.47576 4.55179 5.73769C4.44902 5.99963 4.40267 6.2803 4.41578 6.56137C4.37111 8.20004 4.37111 9.84004 4.41578 11.4814C4.40444 11.7621 4.45198 12.0422 4.55533 12.3034C4.65868 12.5647 4.81556 12.8015 5.01588 12.9985C5.21621 13.1955 5.45555 13.3485 5.71851 13.4475C5.98148 13.5465 6.26225 13.5894 6.54278 13.5734C7.36078 13.6034 8.18078 13.5784 9.00078 13.5784L9.00178 13.5794Z",
    fill: "url(#paint7_linear_1180_652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34277 6.83937C3.37977 6.57437 3.40878 6.30837 3.45678 6.04537C3.54273 5.35041 3.87622 4.70969 4.39616 4.24062C4.9161 3.77156 5.58767 3.50556 6.28778 3.49137C8.10278 3.42937 9.92278 3.42537 11.7368 3.49137C12.5034 3.5011 13.2353 3.81234 13.7741 4.35771C14.3129 4.90309 14.6153 5.63872 14.6158 6.40537C14.6704 8.14737 14.6704 9.89104 14.6158 11.6364C14.6153 12.403 14.3129 13.1387 13.7741 13.684C13.2353 14.2294 12.5034 14.5406 11.7368 14.5504C9.92278 14.6164 8.10178 14.6174 6.28778 14.5504C5.523 14.5293 4.79594 14.2135 4.25851 13.669C3.72107 13.1245 3.41484 12.3934 3.40378 11.6284C3.39478 11.4864 3.36377 11.3454 3.34277 11.2044V6.83937ZM9.00178 13.5794C9.83178 13.5794 10.6628 13.6044 11.4928 13.5734C11.7758 13.5883 12.0588 13.5436 12.3235 13.4423C12.5882 13.3409 12.8287 13.1852 13.0295 12.9851C13.2302 12.785 13.3868 12.5451 13.489 12.2807C13.5912 12.0163 13.6367 11.7335 13.6228 11.4504C13.6601 9.8317 13.6601 8.21238 13.6228 6.59238C13.6384 6.30902 13.5939 6.02557 13.4922 5.76063C13.3905 5.49568 13.234 5.25523 13.0329 5.05504C12.8317 4.85485 12.5905 4.69945 12.3251 4.59903C12.0597 4.49861 11.7761 4.45545 11.4928 4.47237C9.84344 4.43771 8.19344 4.43771 6.54278 4.47237C6.26199 4.4542 5.98053 4.49548 5.71678 4.59351C5.45304 4.69155 5.21294 4.84414 5.01219 5.0413C4.81144 5.23846 4.65456 5.47576 4.55179 5.73769C4.44902 5.99963 4.40267 6.2803 4.41578 6.56137C4.37111 8.20004 4.37111 9.84004 4.41578 11.4814C4.40444 11.7621 4.45198 12.0422 4.55533 12.3034C4.65868 12.5647 4.81556 12.8015 5.01588 12.9985C5.21621 13.1955 5.45555 13.3485 5.71851 13.4475C5.98148 13.5465 6.26225 13.5894 6.54278 13.5734C7.36078 13.6034 8.18078 13.5784 9.00078 13.5784L9.00178 13.5794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9997 6.14355C8.4295 6.14355 7.87209 6.31264 7.39799 6.62943C6.92388 6.94621 6.55437 7.39648 6.33616 7.92328C6.11795 8.45008 6.06085 9.02976 6.1721 9.589C6.28334 10.1483 6.55792 10.6619 6.96111 11.0651C7.36431 11.4683 7.87802 11.7429 8.43726 11.8542C8.99651 11.9654 9.57617 11.9083 10.103 11.6901C10.6298 11.4719 11.08 11.1024 11.3968 10.6283C11.7136 10.1542 11.8827 9.59675 11.8827 9.02655C11.8827 8.26193 11.579 7.52863 11.0383 6.98796C10.4976 6.44729 9.76432 6.14355 8.9997 6.14355ZM8.9997 10.9165C8.6259 10.9165 8.26048 10.8057 7.94967 10.598C7.63886 10.3904 7.39661 10.0952 7.25356 9.74983C7.11051 9.40448 7.07309 9.02446 7.14602 8.65784C7.21894 8.29121 7.39895 7.95445 7.66328 7.69012C7.9276 7.4258 8.26436 7.24579 8.63099 7.17287C8.99761 7.09994 9.37762 7.13738 9.72297 7.28043C10.0683 7.42348 10.3635 7.66572 10.5712 7.97653C10.7789 8.28734 10.8897 8.65274 10.8897 9.02655C10.8886 9.52712 10.6891 10.0068 10.3347 10.3604C9.98039 10.714 9.50027 10.9126 8.9997 10.9126V10.9165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7368 6.00728C12.7368 6.14296 12.6965 6.2756 12.6211 6.38841C12.5457 6.50122 12.4386 6.58915 12.3133 6.64107C12.1879 6.69299 12.05 6.70657 11.9169 6.6801C11.7838 6.65363 11.6616 6.58829 11.5657 6.49236C11.4697 6.39642 11.4044 6.27418 11.3779 6.14111C11.3515 6.00804 11.365 5.87012 11.417 5.74477C11.4689 5.61942 11.5568 5.51227 11.6696 5.43689C11.7824 5.36151 11.9151 5.32129 12.0508 5.32129C12.2327 5.32129 12.4072 5.39357 12.5358 5.52222C12.6645 5.65087 12.7368 5.82534 12.7368 6.00728Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1180_652",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.69006 15.7547) scale(19.8543 19.8543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#FADC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#FBCE0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#FCB720"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#FE9838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#FF7950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#FF1C74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C1CD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1180_652",
    x1: 6.90784,
    y1: 7.84099,
    x2: -23.5858,
    y2: -9.31412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A1B5D8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#90A2BD",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#7C8B9C",
    stopOpacity: 0.757
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#748290"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1180_652",
    x1: 9.00052,
    y1: 15.9079,
    x2: 9.00052,
    y2: 18.7098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#FCA800",
    stopOpacity: 0.306
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627,
    stopColor: "#FE7300",
    stopOpacity: 0.627
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#FF5200",
    stopOpacity: 0.867
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1180_652",
    x1: 7.97166,
    y1: 7.9779,
    x2: 3.53989,
    y2: 3.49195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1180_652",
    x1: 12.335,
    y1: 16.4912,
    x2: 10.1159,
    y2: 6.00618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1180_652",
    x1: 13.1839,
    y1: 13.2076,
    x2: 4.25603,
    y2: 4.28123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1180_652",
    x1: 13.848,
    y1: 7.80142,
    x2: 10.58,
    y2: 5.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833AB4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1180_652",
    x1: 12.575,
    y1: 5.47391,
    x2: 5.39206,
    y2: 12.8598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#833AB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#9C3495"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#DC2546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#FD1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#FC6831"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    stopColor: "#FC9B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#FCAF45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#FDB750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    stopColor: "#FECB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#FFD87A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDC80"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0224609)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.49fe2d08117edb2d78b2a436636335bd.svg";
export { ForwardRef as ReactComponent };